var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.image)?_c('div',{staticClass:"scroll-indicator"},[_c('float',{attrs:{"offset":"-15%"}},[_c('sanity-media',{attrs:{"image":_vm.image,"width":_vm.width,"height":_vm.height}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }